import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String }

    connect() {
        this.container = document.getElementById('messages-container')
        this.messagesList = document.getElementById('messages')

        // Create observer
        this.observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !this.loading) {
                this.loadMore()
            }
        }, {
            threshold: 0,
            rootMargin: '200px',
            root: this.container
        })

        this.observer.observe(this.element)
    }

    disconnect() {
        if (this.observer) this.observer.disconnect()
    }

    loadMore() {
        if (this.loading || !this.urlValue) return
        this.loading = true

        // Stop observing
        this.observer.unobserve(this.element)

        // Capture geometry
        const previousScrollHeight = this.container.scrollHeight
        const previousScrollTop = this.container.scrollTop

        fetch(this.urlValue, {
            headers: {
                "Accept": "application/json",
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok")
                return response.json()
            })
            .then(data => {
                // data = [messages_html, sentinel_html]

                const temp = document.createElement('div')
                temp.innerHTML = data[0]
                const newNodes = Array.from(temp.children)

                // 1. Prepare new sentinel
                let newSentinelNode = null
                if (data[1]) {
                    const sentinelTemp = document.createElement('div')
                    sentinelTemp.innerHTML = data[1]
                    newSentinelNode = sentinelTemp.firstElementChild
                }

                // 2. Prepend messages
                const fragment = document.createDocumentFragment()

                if (newSentinelNode) {
                    fragment.appendChild(newSentinelNode)
                }

                newNodes.forEach(node => {
                    fragment.appendChild(node)
                })

                this.messagesList.prepend(fragment)

                // 3. Remove old sentinel (self)
                // We do this AFTER prepending to keep a valid anchor point if needed?
                // No, we can remove it now.
                this.element.remove()

                // 4. Restore scroll
                const newScrollHeight = this.container.scrollHeight
                const heightDifference = newScrollHeight - previousScrollHeight

                this.container.scrollTop = previousScrollTop + heightDifference
                this.loading = false
            })
            .catch(error => {
                console.error("Infinite scroll error:", error)
                // Visual feedback
                this.element.innerHTML = '<div class="text-xs text-red-400 py-2">Erreur de chargement <button class="underline ml-1" onclick="location.reload()">Réessayer</button></div>'
                this.loading = false
            })
    }
}
